import { FAQCategory } from '../types/faq';
import { HelpCircle, RefreshCw, Scale, Headphones } from 'lucide-react';

export const faqCategories: FAQCategory[] = [
  {
    title: "Vérification du Statut Étudiant",
    icon: HelpCircle,
    questions: [
      {
        question: "Comment vérifier mon statut étudiant ?",
        answer: "1. Accédez à la page **Mes informations** via [votre espace client](https://my.francestudent.org/clientarea.php?action=details)\n2. Cliquez sur le bouton **\"Formulaire de vérification non visible\"**\n3. Remplissez le formulaire de vérification en téléchargeant un document valide prouvant votre statut étudiant"
      },
      {
        question: "Quels documents sont acceptés pour la vérification ?",
        answer: "Les documents acceptés pour la vérification sont listés dans notre [document officiel](https://francestudent.org/docs/cgu.pdf). Cela inclut :\n\n- Les cartes étudiantes en cours de validité\n- Les certificats de scolarité de l'année en cours"
      },
      {
        question: "Combien de temps prend la vérification ?",
        answer: "Le traitement de votre vérification peut prendre quelques heures à quelques jours. Vous recevrez une notification une fois votre statut validé."
      }
    ]
  },
  {
    title: "Renouvellement et Commandes",
    icon: RefreshCw,
    questions: [
      {
        question: "Comment renouveler mon accès ou mes services ?",
        answer: "1. Connectez-vous à [votre espace client](https://my.francestudent.org/clientarea.php?action=details)\n2. Suivez le processus de vérification\n3. Téléchargez vos documents mis à jour"
      },
      {
        question: "Que faire si une offre est en rupture de stock ?",
        answer: "Si une offre comme Canva Pro est en rupture, attendez le prochain réassort. Vous pouvez :\n\n- Recommander via [notre boutique](https://my.francestudent.org/store/canva)\n- Suivre nos mises à jour sur Instagram [@francestudent](https://instagram.com/francestudent)"
      }
    ]
  },
  {
    title: "Aide et Support",
    icon: Headphones,
    questions: [
      {
        question: "Comment contacter le support en cas de problème ?",
        answer: "En cas de problème, vous pouvez nous contacter via notre page de support sur le site ou nous écrire directement à partir de votre espace personnel."
      },
      {
        question: "Comment être informé des nouveautés et mises à jour ?",
        answer: "Restez informé de nos actualités via :\n\n- Notre compte Instagram [@francestudent](https://instagram.com/francestudent)\n- Notre canal de communication officiel"
      }
    ]
  },
  {
    title: "Utilisation des Services",
    icon: Scale,
    questions: [
      {
        question: "Comment accéder à mes services après vérification ?",
        answer: "1. Connectez-vous à votre espace client\n2. Accédez à vos services\n3. Finalisez vos commandes si nécessaire"
      },
      {
        question: "Puis-je utiliser les services sur plusieurs appareils ?",
        answer: "Oui, vous pouvez utiliser nos services sur différents appareils en vous connectant simplement à votre compte."
      }
    ]
  }
];